var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("cellar-wine-list", {
    attrs: {
      loggedUserData: _vm.loggedUserData,
      searchCriterias: _vm.searchCriterias
    }
  });
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };